/**
* Copyright (c) 2018 Microsoft Corporation
* Modules Registration
* THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
*/

const universal = require('react-universal-component').default;
export const componentDictionary = {};

componentDictionary['__local__|__local__|themes|fhi|views|components|cartlineitem'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         'partner/themes/fhi/views/components/cartlineitem.component.tsx'),
         {
            chunkName: () => 'partner-themes-fhi-views-components-cartlineitem.component.tsx',
            ignoreBabelRename: true
         }
    )};
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|cartlineitem'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/cartlineitem.component.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-fabrikam-design-kit-dist-lib-modules-fabrikam-views-components-cartlineitem.component.js',
            ignoreBabelRename: true
         }
    )};
componentDictionary['@msdyn365-commerce-modules|fabrikam-design-kit|modules|fabrikam|views|components|promocode'] = {
component: universal(
   () => import(/* webpackInclude: /.(t|j)sx?$/ */ 
         /* webpackExclude: /.data.|.autogenerated.|.test.|.field.|.data-model./ */
         '@msdyn365-commerce-modules/fabrikam-design-kit/dist/lib/modules/fabrikam/views/components/promocode.component.js'),
         {
            chunkName: () => '@msdyn365-commerce-modules-fabrikam-design-kit-dist-lib-modules-fabrikam-views-components-promocode.component.js',
            ignoreBabelRename: true
         }
    )};